import { render, staticRenderFns } from "./StaffChatSupervise.vue?vue&type=template&id=1e93b356&scoped=true&"
import script from "./StaffChatSupervise.vue?vue&type=script&lang=js&"
export * from "./StaffChatSupervise.vue?vue&type=script&lang=js&"
import style0 from "./StaffChatSupervise.vue?vue&type=style&index=0&id=1e93b356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e93b356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e93b356')) {
      api.createRecord('1e93b356', component.options)
    } else {
      api.reload('1e93b356', component.options)
    }
    module.hot.accept("./StaffChatSupervise.vue?vue&type=template&id=1e93b356&scoped=true&", function () {
      api.rerender('1e93b356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/StaffChatSupervise.vue"
export default component.exports